import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useLoaderData, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { login } from "../../services/auth.services";
import { Link } from "react-router-dom";
import logowide from '../../../../assets/center/images/logo-h.png'
import {
    getSessionKey,
    handleNavigation,
    handleServerValidations,
    removeSessionKey,
    setLocalKey,
    setSessionKey,
    getLocalKey
} from "../../../../utils/commonfunction";
import { SWAL_SETTINGS, COOKIES_EXPIRATION, ROLE, CENTER_LOGIN_ERROR_TYPES, DOCTOR_LOGIN_ERROR_TYPES } from "../../../../utils/Constants";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import CustomError from "../../../../utils/customError";
import { useValidationSchemas } from "../../validator/validation";
import { useSelector } from "react-redux";
import { doctorLogin } from "../../../doctor/services/auth.services";
import { CMSDetails } from "../../../website/services/website.services";
import { UpdateTermsConditionAcceptanceStatus } from "../../../doctor/services/profile.services";


const CenterLogin = () => {
    const { t } = useTranslation()
    const { loginValidationSchema } = useValidationSchemas();
    const [show, setShow] = useState(true);
    const navigate = useNavigate();
    const myGlobalData = useSelector((state) => state.globalData?.data);
    const [getGlobalData, setGlobalData] = useState({});
    const [loginData, setLoginData] = useState({});
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const [showModal, setShowModal] = useState(false);
    const [currentEmail, setCurrentEmail] = useState("");
    const [accepted, setAccepted] = useState(false);
    const [dynamicOptions, setDynamicOptions] = useState([]);
    const roleFromPath = location.pathname.split("/")[1];

    console.log("location --->", location)
    console.log("roleFromPath --->", roleFromPath)

    useEffect(() => {
        const handlePopState = (event) => {
            window.history.pushState(null, null, window.location.href);
        };
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = handlePopState;
        return () => {
            window.onpopstate = null;
        };
    }, []);

    useEffect(() => {
        if (myGlobalData) {
            const settingsData = JSON.parse(myGlobalData);
            setGlobalData(settingsData);
        }
    }, [myGlobalData]);

    useEffect(() => {
        if (![ROLE.CENTER, ROLE.DOCTOR].includes(roleFromPath)) { navigate('/', { replace: true });}
    }, [navigate]);

    /** Remember last logged-in user >>>> */
    useEffect(() => {
        if (roleFromPath === ROLE.CENTER && getSessionKey(`remember-me-center`) === "true") {
            const storedCenterEmail = Cookies.get(`center_email`);
            const storedCenterPass = Cookies.get(`center_password`);
            formik.setFieldValue("email", storedCenterEmail);
            formik?.setFieldValue("password", storedCenterPass);
        } else if (roleFromPath === ROLE.DOCTOR && getSessionKey(`remember-me-doctor`) === "true") {
            const storedDoctorEmail = Cookies.get(`doctor_email`);
            const storedDoctorPass = Cookies.get(`doctor_password`);
            formik.setFieldValue(`email`, storedDoctorEmail);
            formik?.setFieldValue(`password`, storedDoctorPass);
        } else {
            formik.setFieldValue("email", "");
            formik.setFieldValue("password", "");
        }
    }, []);
    /** Remember last logged-in user <<<< */

    const handleshow = () => {
        setShow(!show);
    };



    const handleRememberMe = (e, role) => {
        // const cookiePrefix = userType === ROLE.RESTAURANT ? "rest" : "staff";
        if (role === ROLE.CENTER) {
            if (e.target.checked) {
                setSessionKey(`remember-me-center`, "true");
            } else {
                removeSessionKey(`remember-me-center`);
                Cookies.remove(`center_email`);
                Cookies.remove(`center_password`);
            }
        }
        if (role === ROLE.DOCTOR) {
            if (e.target.checked) {
                setSessionKey(`remember-me-doctor`, "true");
            } else {
                removeSessionKey(`remember-me-doctor`);
                Cookies.remove(`doctor_email`);
                Cookies.remove(`doctor_password`);
            }
        }
        // if (e.target.checked) {
        //     setSessionKey(`remember-me-rest`, "true");
        // } else {
        //     removeSessionKey(`remember-me-rest`);
        //     Cookies.remove(`rest_email`);
        //     Cookies.remove(`rest_password`);
        // }
    }

    const formik = useFormik({
        initialValues: {
            email: "",
            password: ""
        },
        validationSchema: loginValidationSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            const formData = new FormData();
            formData.append("email", values.email.toLowerCase());
            formData.append("password", values.password)
            formData.append("role", roleFromPath);
            if (roleFromPath == 'center') {
                login(formData)
                    .then((response) => {
                        if (response.success) {
                            if (getSessionKey(`remember-me-center`) === "true") {
                                Cookies.set(`center_email`, response?.data?.email, {
                                    expires: COOKIES_EXPIRATION,
                                });
                                Cookies.set(`center_password`, values.password, {
                                    expires: COOKIES_EXPIRATION,
                                });
                            } else {
                                Cookies.remove(`center_email`);
                                Cookies.remove(`center_password`);
                            }
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            // setLocalKey(ROLE.CENTER, JSON.stringify(response.data));
                            // handleNavigation({
                            //     successURL: `/${roleFromPath}/dashboard/1`,
                            //     role: ROLE.CENTER
                            // });
                            setLoginData(response?.data);
                            if (response.data.terms_condition_accept_status === true || response.data.terms_condition_accept_status === "true") {
                                setLocalKey(ROLE.CENTER, JSON.stringify(response.data));
                            handleNavigation({
                                successURL: `/${roleFromPath}/dashboard/1`,
                                role: ROLE.CENTER
                            });
                            }
                            else{
                               setShowModal(true);
                            }
                            // let getSessionTerms = getLocalKey(`term_condition${response?.data?.email}`);
                            // if (getSessionTerms == 'true') {
                            //     setLocalKey(ROLE.CENTER, JSON.stringify(response.data));
                            //     handleNavigation({
                            //         successURL: `/${roleFromPath}/dashboard/1`,
                            //         role: ROLE.CENTER
                            //     });
                            // } else {
                            //     setShowModal(true);
                            //     setCurrentEmail(response?.data?.email);
                            // }
                        } else {
                            let message = handleServerValidations(response);
                            /** Handling different types of server errors */
                            const supportUrlConditions = [CENTER_LOGIN_ERROR_TYPES.ACCOUNT_IS_BLOCKED];
                            // if (supportUrlConditions.indexOf(response.error_type) !== -1) {
                            //     message += `<a className="d-block mt-2 no-decoration link-text" href="/support/${response.error_type}">${t('Contact Us')}</a>`;
                            // }
                            Swal.fire({
                                icon: "error",
                                html: message,
                                ...SWAL_SETTINGS
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>", error)
                    })
            } else {
                doctorLogin(formData)
                    .then((response) => {
                        if (response.success) {
                            if (getSessionKey(`remember-me-doctor`) === "true") {
                                Cookies.set(`doctor_email`, response?.data?.email, {
                                    expires: COOKIES_EXPIRATION,
                                });
                                Cookies.set(`doctor_password`, values.password, {
                                    expires: COOKIES_EXPIRATION,
                                });
                            } else {
                                Cookies.remove(`doctor_email`);
                                Cookies.remove(`doctor_password`);
                            }
                            setLoginData(response?.data);
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            // setLocalKey(ROLE.DOCTOR, JSON.stringify(response.data));
                            // handleNavigation({
                            //     successURL: `/${roleFromPath}/dashboard/1`,
                            //     role: ROLE.DOCTOR
                            // });
                            if (response.data.terms_condition_accept_status === true || response.data.terms_condition_accept_status === "true") {
                                setLocalKey(ROLE.DOCTOR, JSON.stringify(response.data));
                                handleNavigation({
                                    successURL: `/${roleFromPath}/dashboard/1`,
                                    role: ROLE.DOCTOR
                                });
                            } else {
                                setShowModal(true);
                            }
                            // let getSessionTerms = getLocalKey(`term_condition${response?.data?.email}`);
                            // if (getSessionTerms == 'true') {
                            //     setLocalKey(ROLE.DOCTOR, JSON.stringify(response.data));
                            //     handleNavigation({
                            //         successURL: `/${roleFromPath}/dashboard/1`,
                            //         role: ROLE.DOCTOR
                            //     });
                            // } else {
                            //     setShowModal(true);
                            //     setCurrentEmail(response?.data?.email);
                            // }
                        } else {
                            let message = handleServerValidations(response);
                            /** Handling different types of server errors */
                            const supportUrlConditions = [DOCTOR_LOGIN_ERROR_TYPES.ACCOUNT_IS_BLOCKED];
                            // if (supportUrlConditions.indexOf(response.error_type) !== -1) {
                            //     message += `<a className="d-block mt-2 no-decoration link-text" href="/support/${response.error_type}">${t('Contact Us')}</a>`;
                            // }
                            Swal.fire({
                                icon: "error",
                                html: message,
                                ...SWAL_SETTINGS
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>", error)
                    })
            }
        }
    });


    const handleAccept = () => {
        if (accepted) {
            setLocalKey(roleFromPath === 'center' ? ROLE.CENTER : ROLE.DOCTOR, JSON.stringify(loginData));
            setLocalKey(`term_condition${currentEmail}`, 'true');
            handleNavigation({
                successURL: `/${roleFromPath}/dashboard/1`,
                role: roleFromPath === 'center' ? ROLE.CENTER : ROLE.DOCTOR
            });
            setShow(false);
        }
    };

    const cmsSlug = roleFromPath === 'center' ? 'center_terms_condition' : 'doctor_terms_condition';

    useEffect(() => {
        CMSDetails(cmsSlug).then((response) => {
            setDynamicOptions(response?.data);
        }).catch((error) => {
            console.log("error of terms&conditions", error);
        });
    }, []);

    // console.log("dynamicOptions",dynamicOptions)

    const handleStatusChanged = () => {
        UpdateTermsConditionAcceptanceStatus(roleFromPath === 'center' ? ROLE.CENTER : ROLE.DOCTOR, loginData.token).then((response) => {
            if (response?.success) {
                setShowModal(false);
                setLocalKey(roleFromPath === 'center' ? ROLE.CENTER : ROLE.DOCTOR, JSON.stringify(loginData));
                handleNavigation({
                    successURL: `/${roleFromPath}/dashboard/1`,
                    role: roleFromPath === 'center' ? ROLE.CENTER : ROLE.DOCTOR
                });
            }
        }).catch((error) => {
            console.log("error of terms&conditions", error);
        });
    };

    return (
        <>
            <div className="auth-body d-flex align-items-center justify-content-center">
                <div className="auth-box">
                    <div className="form-box-inner d-flex flex-column gap-5">
                        <div className="form-logo">
                            <img src={logowide} />
                        </div>
                        <div className="form-card">
                            <div className="form-text">
                                <h5 className="mt-2">{t("center.login.heading")}</h5>
                                <p>{t("center.login.description")}</p>
                            </div>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="form-group mb-3">
                                    <label htmlFor="email" className="form-label">
                                        {t("center.login.login_label_email")}
                                        <span>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="email"
                                        name="email"
                                        placeholder={t("center.login.login_placeholder_email")}
                                        value={formik?.values?.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <span className="text-danger d-flex text-left">
                                        <CustomError name="email" form={formik} />
                                    </span>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="password" className="form-label">
                                        {t("center.login.label_password")}
                                        <span>*</span>
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type={!show ? "text" : "password"}
                                            id="password"
                                            name="password"
                                            className="form-control border-end-0"
                                            placeholder={t("center.login.label_password")}
                                            value={formik?.values?.password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        <span
                                            className="input-group-text cp restaurant-password-toggle"
                                            onClick={() => {
                                                handleshow("password");
                                            }}
                                        >
                                            {!show === true ? <i className="ti ti-eye"></i> : <i className="ti ti-eye-off"></i>}
                                        </span>
                                    </div>
                                    <span className="text-danger d-flex text-left">
                                        <CustomError name="password" form={formik} />
                                    </span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="rest-remember-me"
                                            value={"true"}
                                            defaultChecked={
                                                roleFromPath === "doctor"
                                                    ? Boolean(Cookies.get("doctor_email") && Cookies.get("doctor_password"))
                                                    : Boolean(Cookies.get("center_email") && Cookies.get("center_password"))
                                            }
                                            onChange={(e) => handleRememberMe(e, roleFromPath)}
                                        />
                                        <label className="form-check-label" htmlFor="rest-remember-me">
                                            {t("center.login.remember_me")}
                                        </label>
                                    </div>
                                    <Link
                                        className="link-text"
                                        to={{
                                            pathname: `/${roleFromPath}/forget-password`,
                                        }}
                                        state={{ select_role: roleFromPath }}
                                    >
                                        Forgot Password
                                    </Link>
                                </div>
                                <button className="btn btn-primary mt-4 justify-content-center w-100"> {t("center.login.login")}</button>
                            </form>
                        </div>
                        <div className="d-flex justify-content-center">
                            {/* <div className="back-text  d-flex gap-2 align-items-center">
                                <i className="ti ti-arrow-left"></i>
                                <Link class="link-text" to="/">
                                    Back
                                </Link>
                            </div> */}
                            <div
                            className="back-text d-flex gap-2 align-items-center"
                            onClick={() => {
                                const baseUrl = process.env.REACT_APP_WEB_BASE_URL;
                                if (baseUrl) {
                                window.location.href = baseUrl; // Redirect in same tab
                                } else {
                                console.error("Base URL is not defined in environment variables.");
                                }
                            }}
                            style={{ cursor: "pointer" }}
                            >
                            <i className="ti ti-arrow-left"></i>
                            <span className="link-text">Back</span>
                            </div>
                                        
                        </div>
                    </div>
                </div>
            </div>

            {/* Terms and Condition Model */}
            <div
                className={`modal fade ${showModal ? "show" : ""}`}
                id="modalUploadDocument"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden={!showModal}
                style={{ display: showModal ? "block" : "none" }}
            >
                <div className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: "800px" }}>
                    <div className="modal-content">
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h3 className="modal-title" id="exampleModalLabel">
                                {t("Terms and Conditions")}
                            </h3>
                            {/* <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button> */}
                        </div>

                        {/* Modal Body */}
                        <div className="modal-body">
                            <div className="terms-box p-3 border rounded bg-light" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: dynamicOptions && dynamicOptions?.description ? dynamicOptions.description : "N/A",
                                    }}
                                ></div>
                            </div>

                            <div className="form-check mt-4">
                                <input className="form-check-input" type="checkbox" id="acceptTerms" checked={accepted} onChange={() => setAccepted(!accepted)} />
                                <label className="form-check-label" htmlFor="acceptTerms">
                                    {t("I accept the Terms and Conditions")}
                                </label>
                            </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer">
                            <button className="btn btn-primary" onClick={handleStatusChanged} disabled={!accepted}>
                                {t("Accept and Continue")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Backdrop */}
            {showModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
}

export default CenterLogin